import axios from "@/axios";
import VueCookies from "vue-cookies";
const fetchClientInfo = async (clientId) => {
    let url = `/client/${clientId}/new`;
    try {
        let { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.log("Error:>>>>", error);
    }
};

const initializeClient = async (payload) => {
    const url = `/client/init`;
    const { data } = await axios.post(url, payload);
    return data.data;
};

const onBoardClient = async (clientId) => {
    let res = {
        data: null,
        error: null,
    };
    const url = `/client/${clientId}/onboard`;
    try {
        const { data } = await axios.post(url);
        res.data = data;
    } catch (error) {
        res.error = error;
    }
    return res;
};

const updateClientInfo = async (clientId, payload) => {
    const url = `/client/${clientId}`;
    const { data } = await axios.patch(url, payload);
    return data;
};

const clientUsers = async (clientId) => {
    const url = `/user/client/${clientId}`;
    const { data } = await axios.get(url);
    return data;
}
const clientGroups = async (clientId) => {
    const url = `/group/client/${clientId}`;
    const { data } = await axios.get(url);
    return data;
}
// Contacts
const fetchClientContacts = async (clientId) => {
    let url = `/client/${clientId}/contact`;

    let { data } = await axios.get(url);
    return data;
};

const createAndUpdateClientContacts = async (clientId, payload) => {
    let url = `/client/${clientId}/contact`;

    let { data } = await axios.put(url, payload);
    return data;
};

// ENd Contacts

// Address
const getAddresses = async (clientId) => {
    let url = `/client/${clientId}/address`;

    let { data } = await axios.get(url);
    return data;
};

const createAndUpdateClientAddress = async (clientId, payload) => {
    let url = `/client/${clientId}/address`;

    let { data } = await axios.put(url, payload);
    return data;
};

// End Address

const getCurrencyList = async () => {
    let url = `/data/dropdown/currency`;
    // let token = VueCookies.get("token");
    let token = VueCookies.get("tenant_token") || VueCookies.get("client_token");
    try {
        let { data } = await axios.get(url,{headers: {
            'Authorization':`Bearer ${token}`
          }});
        return data;
    } catch (error) {
        console.log("Error:>>>>", error);
    }
};

const fetchTenantCurrencyDetails = async (currencyId) => {
    let url = `/currency/${currencyId}`
    try {
        let { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.log("Error:>>>>", error);
    }
}

const fetchTenantDetails = async (tenantId) => {
    let url = `/tenant/${tenantId}`
    try {
        let { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.log("Error:>>>>", error);
    }
}

const getCountryList = async () => {
    // let token = VueCookies.get("token");
    let token = VueCookies.get("tenant_token") || VueCookies.get("client_token");
    let url = `/data/dropdown/country`;
    try {
        let { data } = await axios.get(url,{headers: {
            'Authorization':`Bearer ${token}`
          }});
        return data;
    } catch (error) {
        console.log("Error:>>>>", error);
    }
};

const getChecksAssignedtoClient = async (clientId) => {
    const url = `/tenant-check/client-checks/${clientId}`;
    try {
        let { data } = await axios.get(url);
        return data.data;
    } catch (error) {
        console.log(error);
    }
};

const getAllClientPackages = async (clientId) => {
    const url = `/screening-package/client/${clientId}`;
    try {
        let { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.log("error>>", error);
    }
};

const getTenantDashboards = async () => {
    const url = `/dashboard/assigned-dashboards`
    return await axios.get(url)
}
const getEmailTempaltes = async (external_id) => {
    const url = `/email-template/dashboard-filter-templates?external_id=${external_id}`
    return await axios.get(url)
}
const getClientEmailTemplate = async (clientId) => {
    const url = `/email-template/assigned-email-template?client_id=${clientId}`
    return await axios.get(url)
}
const getClientDashboards = async (clientId) => {
    const url = `/dashboard/client/assigned-dashboards/${clientId}`
    return await axios.get(url)
}

const  getDashboardUsersAndGroups = async (dashboardId,clientId) => {
    const url = `/client/dashboard-users/${dashboardId}/clients/${clientId}`;
    return await axios.get(url)
}

const assignDashboard = async (payload) => {
    const url = '/client/assign-dashboard';
    // let token = VueCookies.get("token");
    let token = VueCookies.get("tenant_token") || VueCookies.get("client_token");
    await axios.post(url, payload,{headers: {
        'Authorization':`Bearer ${token}`
    }})
}

const updateClientDashboard = async (clientId, payload) => {
    const url = `/client/assign-dashboards-client/${clientId}`;
    const { data } = await axios.post(url, payload);
    return data;
};

const updateGroupsUsers = async (dashboardId, clientId, payload) => {
    const url = `/client/assign-users-dashboard/${dashboardId}/clients/${clientId}`;
    const { data } = await axios.post(url, payload);
    return data;
};

const getDashboardSortOptions = async (payload) => {
    const url = `/dashboard/assigned-dashboards/reorder`
    const {data} = await axios.post(url, payload);
    return data;
}

const validEmail = (value) => {
    // eslint-disable-next-line no-useless-escape
    const nameValue = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return nameValue.test(value);
  };

export { 
    fetchClientInfo, 
    initializeClient, 
    updateClientInfo, 
    fetchClientContacts, 
    createAndUpdateClientContacts, 
    getAddresses, 
    createAndUpdateClientAddress, 
    getCurrencyList, 
    onBoardClient, 
    getChecksAssignedtoClient, 
    getAllClientPackages, 
    getCountryList,
    fetchTenantCurrencyDetails,
    fetchTenantDetails,
    getTenantDashboards,
    getClientDashboards,
    assignDashboard,
    validEmail,
    getEmailTempaltes,
    getClientEmailTemplate,
    getDashboardUsersAndGroups,
    clientUsers,
    clientGroups,
    updateClientDashboard,
    updateGroupsUsers,
    getDashboardSortOptions,
};
